import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Radar } from "lucide-react";

export default function ScannerSnapshot() {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    const load = () => {
      const qs = localStorage.getItem("veerox_admin_scope_all") === "1" ? "?all=true" : "";
      api.get(`/scanner/overview${qs}`).then((r) => setCards(r.data.scanner || [])).catch(() => {});
    };
    load();
    const iv = setInterval(load, 30000);
    return () => clearInterval(iv);
  }, []);

  const top = [...cards].sort((a, b) => (b.signals_24h || 0) - (a.signals_24h || 0)).slice(0, 3);

  return (
    <div className="vx-card" data-testid="scanner-snapshot">
      <div className="px-5 py-3 border-b border-[#1f2937] flex items-center justify-between">
        <div className="vx-label">Scanner Snapshot</div>
        <Link to="/scanner" className="text-[10px] uppercase tracking-widest text-[#3b82f6] hover:underline font-bold" data-testid="scanner-snapshot-link">
          Open ↗
        </Link>
      </div>
      <div className="divide-y divide-[#1f2937]">
        {top.length === 0 ? (
          <div className="px-5 py-6 text-center text-xs text-[#6b7280] font-mono flex flex-col items-center gap-2">
            <Radar className="w-5 h-5 opacity-50" />
            No activity yet
          </div>
        ) : top.map((c) => (
          <div key={c.symbol} className="px-5 py-3 flex items-center justify-between text-xs">
            <div>
              <div className="font-mono font-semibold">{c.symbol}</div>
              <div className="text-[10px] text-[#6b7280] font-mono">{c.timeframe} · {c.trend_regime}</div>
            </div>
            <div className="text-right">
              <div className="font-mono font-bold text-[#3b82f6]">{c.signals_24h} sig</div>
              <div className="text-[9px] text-[#6b7280] font-mono">24h</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
